import React from 'react'

import { Span } from 'components'
import { ErrorBoundariesIcon } from 'components/Icons'
import { ErrorContainer } from './styles'

type IProps = {
  targetComponentName?: string
  children: React.ReactNode
}

type IState = {
  hasError: boolean
  errorMessage: string
}

type IError = {
  message: string
  stack: string
}

class ErrorBoundary extends React.Component<IProps, IState> {
  state: IState = {
    hasError: false,
    errorMessage: '',
  }

  static getDerivedStateFromError(error: IError) {
    return {
      hasError: true,
      errorMessage: error.message,
    };
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorBoundariesIcon size={60} />
          <Span
            fontWeight="bold"
            text="Algo deu errado."
            fontSize="1.5rem"
          />
          {this.props.targetComponentName && <Span text={`Ao Carregar: ${this.props.targetComponentName}`} />}
          <Span text={`Erro: ${this.state.errorMessage}`} />
        </ErrorContainer>
      )
    }

    return this.props.children;
  }
}

export default ErrorBoundary
